/*
 * Discount code form: forwards to Shopify's native /discount/{code} endpoint,
 * which stores the code and applies it at checkout.
 */
class DiscountForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(event) {
    event.preventDefault();
    const code = this.form.querySelector('input[name="code"]').value.trim();
    if (!code) return;
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(window.location.pathname)}`;
  }
}

customElements.define('discount-form', DiscountForm);
